// extracted by mini-css-extract-plugin
export default {"block":"SocialPostInfo_block__mQwoj"};